import { FormSectionHeader, ValidatedForm } from "../../../../../components/forms";
import { type QuestionSettingsProps } from "./types";

import "./questionSettings.scss";
import { noop } from "lodash";

const inputMasks = new Map<string, RegExp>([
  ["percentageValue", /^[1-9]\d?$|^100$|^$/],
  ["attemptsCount", /^(?:999|[1-9]\d{0,2})$/],
  ["periodValue", /^(?:99|[1-9]\d{0,2})$/],
]);

function QuestionSettings(props: QuestionSettingsProps) {
  const { values, onBlur, onChanged, validatedFieldProps, disabled, mask, isReadOnlyView } = props;
  const inMask = mask === undefined ? inputMasks.get("percentageValue") : mask;

  if (isReadOnlyView) {
    const useEmptyState = !values.showCorrectAnswers && !values.percentageRequired;
    return (
      <div className="question-settings-read-only">
        <span>Question Settings</span>
        {useEmptyState && <div className="question-settings-read-only__value">No question settings applied</div>}
        {values.showCorrectAnswers && (
          <div className="question-settings-read-only__value">Show which answers are correct after completed</div>
        )}
        {values.percentageRequired && (
          <div className="question-settings-read-only__value">
            {`Percentage required to pass: ${values.percentageValue}`}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={"question-settings-block"}>
      <FormSectionHeader title="Question settings" />

      <ValidatedForm.CheckboxField
        {...validatedFieldProps}
        toggle
        label="Show which answers are correct after completed"
        value={values.showCorrectAnswers}
        propertyName="showCorrectAnswers"
        handleChange={onChanged}
        disabled={disabled}
      />

      <div className={"percentage-block"}>
        <ValidatedForm.CheckboxField
          {...validatedFieldProps}
          toggle
          label="Percentage required to pass"
          value={values.percentageRequired}
          propertyName="percentageRequired"
          handleChange={onChanged}
          disabled={disabled}
        />

        <ValidatedForm.InputField
          placeholder="0"
          maxLength={3}
          value={values.percentageValue}
          propertyName="percentageValue"
          onBlur={onBlur}
          disabled={disabled || !values.percentageRequired}
          {...validatedFieldProps}
          handleChange={noop}
          mask={inMask}
        />
      </div>
    </div>
  );
}

export default QuestionSettings;
